import { render, staticRenderFns } from "./UpdateUser.vue?vue&type=template&id=244d2da2&scoped=true&"
import script from "./UpdateUser.vue?vue&type=script&lang=js&"
export * from "./UpdateUser.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUser.vue?vue&type=style&index=0&id=244d2da2&scoped=true&lang=css&"
import style1 from "./UpdateUser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d2da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244d2da2')) {
      api.createRecord('244d2da2', component.options)
    } else {
      api.reload('244d2da2', component.options)
    }
    module.hot.accept("./UpdateUser.vue?vue&type=template&id=244d2da2&scoped=true&", function () {
      api.rerender('244d2da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuperAdmin/UpdateUser.vue"
export default component.exports